import * as React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import TaxonomyThemeTeaser from './Teaser';
import type { TaxonomyTheme } from '../../../types/uncinc_profile/taxonomy';

type ThemeViewmode = 'teaser' | 'page' | 'title';

interface ThemeProps {
  entity: ImmutableEntity<TaxonomyTheme>;
  viewMode: ThemeViewmode;
}

const TaxonomyThemeWrapper: React.FC<ThemeProps> = ({ entity, viewMode, ...props }) => {
  switch (viewMode) {
    case 'teaser':
    default:
      return <TaxonomyThemeTeaser entity={entity} {...props} />;
  }
};

export default TaxonomyThemeWrapper;
